if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`, {
        scope: './',
    });
} else {
    console.log('The current browser doesnt support service workers.');
}
